import type { Ng1StateDeclaration } from '@uirouter/angularjs/lib/interface';
import type { Transition } from '@uirouter/angularjs';
import { StateDeclaration } from '@uirouter/core';

export const externalAuthState: Ng1StateDeclaration = {
	name: 'externalAuth.**',
	url: '/externalAuth',
	data: {
		isAnonymous: true,
	},

	lazyLoad: async function (transition: Transition) {
		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
		const { externalAuthModule } = await import(/* webpackChunkName: "externalAuth" */ './externalAuth.module');
		const { authExchangeState, authOldExchangeState, authAcsState, acsRedirectState, createAcsAppState } = await import(
			/* webpackChunkName: "externalAuth" */ './externalAuth.lazy.states'
		);
		await $ocLazyLoad.inject({
			name: externalAuthModule.name,
		});

		return { states: [authExchangeState, authOldExchangeState, authAcsState, acsRedirectState, createAcsAppState] as Array<StateDeclaration> };
	},
};
